module.exports = __webpack_public_path__ + "img/lxwmimg.167b868b.jpg";